"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FXOptionTrade = exports.SwapTrade = exports.InventoryTrade = exports.CreditLineTrade = exports.PledgeTrade = exports.EquityTrade = exports.FXTrade = exports.AccountBalanceTrade = exports.RetailAccountTrade = exports.ReportingTrade = exports.BondTrade = exports.DepositTrade = exports.LoanTrade = exports.Trade = void 0;
class Trade {
}
exports.Trade = Trade;
class LoanTrade extends Trade {
}
exports.LoanTrade = LoanTrade;
class DepositTrade extends Trade {
}
exports.DepositTrade = DepositTrade;
class BondTrade extends Trade {
}
exports.BondTrade = BondTrade;
class ReportingTrade extends Trade {
}
exports.ReportingTrade = ReportingTrade;
class RetailAccountTrade extends Trade {
}
exports.RetailAccountTrade = RetailAccountTrade;
class AccountBalanceTrade extends Trade {
}
exports.AccountBalanceTrade = AccountBalanceTrade;
class FXTrade extends Trade {
}
exports.FXTrade = FXTrade;
class EquityTrade extends Trade {
}
exports.EquityTrade = EquityTrade;
class PledgeTrade extends Trade {
}
exports.PledgeTrade = PledgeTrade;
class CreditLineTrade extends Trade {
}
exports.CreditLineTrade = CreditLineTrade;
class InventoryTrade extends Trade {
}
exports.InventoryTrade = InventoryTrade;
class SwapTrade extends Trade {
}
exports.SwapTrade = SwapTrade;
class FXOptionTrade extends Trade {
}
exports.FXOptionTrade = FXOptionTrade;
//# sourceMappingURL=trade.js.map